<template>
  <component :is="announcementData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="announcementData === undefined">
      <h4 class="alert-heading">獲取項目數據時出錯</h4>
    </b-alert>

    <announcement-edit-tab-information
      v-if="announcementData"
      :announcementData="announcementData"
      :loading="loading"
      @refetch-data="refetchData"
      class="p-sm-2"
    />

  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onMounted } from "@vue/composition-api";
import store from "@/store";
import AnnouncementEditTabInformation from "./announcementEditTabInformation.vue";

export default {
  components: {
    AnnouncementEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const announcementData = ref({id: 1, value: '', contents: ''});
    const loading = ref(false);

    const refetchData = () => {
      loading.value = true;
        store
          .dispatch("app/fetchSettingInfo", 1 )
          .then((response) => {
            announcementData.value = response.data.setting;
            announcementData.value.contents = JSON.parse(response.data.setting.value);
            loading.value = false
          })
          .catch((error) => {
            console.log("error when fetching announcement", error);
            if (error.response.status === 404) {
              announcementData.value = undefined;
            }
            loading.value = false
          });
    };


    onMounted(() => {
      refetchData();
    });

    return {
      refetchData,
      announcementData,
      loading,
    };
  },
};
</script>
